var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSingleSideArrow = function SvgSingleSideArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "singleSideArrow_svg__nav-symbol",
    viewBox: "0 0 7 12.6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 .9 6.3.1 0 6.6l6.3 6.2.7-.7-5.6-5.5L7 .9z"
  })));
};
export default SvgSingleSideArrow;